import React from 'react';
import PropTypes from 'prop-types';

import {PAYMENT_TYPES} from '../../state/payments/billing';

import '../CheckoutPaymentDetails/checkout-payment-details.less';

const ApplePayOption = ({
  canUseApplePay,
  i18n,
  onApplePay,
  paymentInfo,
  processingForm,
}) => {
  if (!canUseApplePay || paymentInfo.paymentOption !== PAYMENT_TYPES.APPLE_PAY) {
    return null;
  }

  return (
    <React.Fragment>
      <button
        lang={i18n.safeLanguage}
        className="apple-pay__button"
        onClick={onApplePay}
        style={{
          WebkitAppearance: '-apple-pay-button',
          ApplePayButtonType: 'buy',
        }}
        type="button"
        disabled={processingForm}
      />
      <button id="js-apple-submit" type="submit" style={{display: 'none'}} />
    </React.Fragment>
  );
};

ApplePayOption.propTypes = {
  canUseApplePay: PropTypes.bool,
  i18n: PropTypes.shape({
    safeLanguage: PropTypes.string.isRequired,
  }).isRequired,
  onApplePay: PropTypes.func.isRequired,
  paymentInfo: PropTypes.shape({
    paymentOption: PropTypes.string,
    paymentToken: PropTypes.string,
  }).isRequired,
  processingForm: PropTypes.bool,
};

ApplePayOption.defaultProps = {
  canUseApplePay: false,
  processingForm: false,
};

export default ApplePayOption;



// WEBPACK FOOTER //
// ./spa/Components/AddPaymentMethod/ApplePayOption.jsx